module.exports = __webpack_public_path__ + "img/tiger-butterfly.9cee4579.png";